import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';

import decor6 from '../../../assets/images/popup/crash-decor-6.png';
import decor5 from '../../../assets/images/popup/crash-decor-5.png';
import decor4 from '../../../assets/images/popup/crash-decor-4.png';
import decor3 from '../../../assets/images/popup/crash-decor-3.png';
import decor2 from '../../../assets/images/popup/crash-decor-2.png';
import decor1 from '../../../assets/images/popup/crash-decor-1.png';
import { globalTranslationKeys } from '../../../enums';
import { chartStore } from '../../../store/chartStore';

export const RoundFinPopUp = observer(() => {
  const t = useTranslation();
  const { crashedOdd } = chartStore;

  return (
    <div className='crash-announcement-holder'>
      <div className='crash-announcement active'>
        <button
          className='crash-announcement-close'
          aria-label='Close'
          onClick={() => chartStore.resetChartData()}
        >
          <i className='ui-lib-close-x' />
        </button>
        <div className='crash-announcement-content'>
          <p
            className='crash-announcement-content-heading'
            title={t(globalTranslationKeys.GameResult)}
          >
            {t(globalTranslationKeys.GameResult)}
          </p>
          <p className='crash-announcement-content-points'>x{crashedOdd}</p>
        </div>
        <div className='crash-announcement-decorations'>
          <img alt='' src={decor6} style={{ animationDelay: '0ms' }} />
          <img alt='' src={decor5} style={{ animationDelay: '-2000ms' }} />
          <img alt='' src={decor4} style={{ animationDelay: '-4000ms' }} />
          <img alt='' src={decor3} style={{ animationDelay: '-6000ms' }} />
          <img alt='' src={decor2} style={{ animationDelay: '-8000ms' }} />
          <img alt='' src={decor1} style={{ animationDelay: '-10000ms' }} />
        </div>
      </div>
    </div>
  );
});
